import * as React from 'react';

import { FocusTrap } from 'focus-trap-react';

import { Button, Row, Col, cn } from '../..';

export type DialogClosingConfirmationProps = {
  isOpen: boolean;
  message: string;
  onCancel: () => void;
  onDiscard: () => void;
};

export const DialogClosingConfirmation = ({
  isOpen,
  message,
  onCancel,
  onDiscard,
}: DialogClosingConfirmationProps) => {
  const discardButtonRef = React.useRef<HTMLButtonElement | null>(null);

  React.useEffect(() => {
    if (isOpen) {
      discardButtonRef.current?.focus();
    }
  }, [isOpen]);

  return (
    <div className="@DialogClosingConfirmation contents">
      <FocusTrap
        active={isOpen}
        focusTrapOptions={{
          allowOutsideClick: true,
          returnFocusOnDeactivate: true,
        }}
      >
        <Col
          xCenter
          yCenter
          className={cn(
            'pointer-events-none absolute inset-0 z-50 rounded-lg border-2 border-space opacity-0 transition-all',
            isOpen && 'pointer-events-auto bg-foreground/20 opacity-100',
          )}
        >
          <Col className={'rounded-lg bg-space p-5 shadow-lg'} xCenter gap4>
            <span>{message}</span>
            <Row gap2>
              <Button variant="outline" onPress={onCancel}>
                Cancel
              </Button>
              <Button
                color="neutral"
                ref={discardButtonRef}
                onPress={onDiscard}
              >
                Discard
              </Button>
            </Row>
          </Col>
        </Col>
      </FocusTrap>
    </div>
  );
};
